// extracted by mini-css-extract-plugin
module.exports = {"HeadSlider":"HeadSlider_HeadSlider__2CbD8","img":"HeadSlider_img__jLcln","SliderDesc":"HeadSlider_SliderDesc__3o_6N"};